export type CouponType = 'correction' | 'giftcard' | 'newdate' | 'reimburse';

export type CouponFormData = {
  customerId: string;
  reason: string;
  type: CouponType;
};

export type SelectOption = {
  id: string;
  label: string;
  value: string;
};

export const COUPON_TYPE_OPTIONS: SelectOption[] = [
  { id: 'giftcard', value: 'Coupons::Goodwills::GiftCard', label: 'Geschenkkarte' },
  { id: 'correction', value: 'Coupons::Goodwills::Correction', label: 'Korrektur' },
  { id: 'newdate', value: 'Coupons::Goodwills::NewDate', label: 'Neues Datum' },
  { id: 'reimburse', value: 'Coupons::Goodwills::Reimbursement', label: 'Erstattung' },
];
